export default "__VITE_PUBLIC_ASSET__63e18921__"